<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div slot="title">
      Kérelem megtekintése
      <el-tag
        v-if="representativeTransferRequest.status"
        size="small"
        :type="getStatus().tag"
        style="margin-left: 5px;"
      >
        {{ getStatus().label }}
      </el-tag>
    </div>
    <div v-loading="loading">
      <el-form
        ref="requestForm"
        label-position="top"
        :model="representativeTransferRequest"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              prop="source_user"
              label="Átadó"
            >
              <el-input
                :value="representativeTransferRequest.source_user && representativeTransferRequest.source_user.full_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="target_user"
              label="Átvevő"
            >
              <el-input
                :value="representativeTransferRequest.target_user && representativeTransferRequest.target_user.full_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="creator_user"
              label="Létrehozó"
            >
              <el-input
                :value="representativeTransferRequest.creator_user && representativeTransferRequest.creator_user.full_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="recorded_at"
              label="Rögzítve"
            >
              <el-input
                :value="representativeTransferRequest.recorded_at | dateTime"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="Létrehozva"
              prop="created_at"
            >
              <el-input
                :value="representativeTransferRequest.created_at | dateTime"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Módosítva"
              prop="updated_at"
            >
              <el-input
                :value="representativeTransferRequest.updated_at | dateTime"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-table
          :data="representativeTransferRequest.items"
          style="width: 100%; margin-top: 20px;"
        >
          <el-table-column
            prop="product_pack_type.product.name"
            label="Termék"
            min-width="200"
          />
          <el-table-column
            prop="product_pack_type.name"
            label="Kiszerelés"
            min-width="120"
          />
          <el-table-column
            prop="count"
            label="Mennyiség"
            width="100"
          />
        </el-table>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="handleClose"
      >
        Bezárás
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['representativeTransferRequestId'],
    data() {
      return {
        loading: false,
        representativeTransferRequest: {
          status: '',
          items: [],
          source_user: {},
          target_user: {},
          creator_user: {},
          recorded_at: '',
          created_at: '',
          updated_at: '',
        },
      };
    },
    async mounted() {
      this.loading = true;
      if (this.representativeTransferRequestId) {
        const request = await this.$store.dispatch('representativeTransferRequest/fetch', this.representativeTransferRequestId);
        this.representativeTransferRequest = request;
      }
      this.loading = false;
    },
    methods: {
      handleClose() {
        this.$router.replace('/representative-processes/representative-transfer-requests');
      },
      getStatus() {
        switch (this.representativeTransferRequest.status) {
          case 'open':
            return {
              label: 'Nyitott',
              tag: 'info',
            };
          case 'refused':
            return {
              label: 'Elutasítva',
              tag: 'danger',
            };
          case 'completed':
            return {
              label: 'Teljesítve',
              tag: 'success',
            };
          default:
            return {
              label: '',
              tag: '',
            };
        }
      },
    },
  };
</script>
